/**
 * Card selection (Leo, 2026-09-28): the card panel you click keeps its copper
 * highlight until you click another one. One highlighted card per page.
 * Delegated from the document, so cards mounted later need no wiring, and
 * stored as a data attribute so React's className updates never clear it.
 */
export const CARD_SELECTOR = '.ce-card';
export const SELECTED_ATTR = 'data-ce-selected';

export function installCardSelection(doc: Document = document): () => void {
  const onClick = (e: MouseEvent) => {
    const target = e.target as Element | null;
    const card = target?.closest?.(CARD_SELECTOR);
    if (!card) return;
    doc.querySelectorAll(`[${SELECTED_ATTR}]`).forEach((el) => {
      if (el !== card) el.removeAttribute(SELECTED_ATTR);
    });
    card.setAttribute(SELECTED_ATTR, '');
  };
  doc.addEventListener('click', onClick);
  return () => doc.removeEventListener('click', onClick);
}
